import * as api from './constants'

/**
 * Get sales summary.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getSalesSummary (queryparams) {
  return axios
    .get(`${api.SALES_SUMMARY_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

export function getGrossProfit (queryparams) {
  return axios
    .get(`${api.GROSS_PROFIT_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get payment methods.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getPaymentMethods (queryparams) {
  return axios
    .get(`${api.PAYMENT_METHODS_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get item sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getItemSales (queryparams) {
  return axios
    .get(`${api.ITEM_SALES_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get category sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getCategorySales (queryparams) {
  return axios
    .get(`${api.CATEGORY_SALES_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get modifier sales.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getModifierSales (queryparams) {
  return axios
    .get(`${api.MODIFIER_SALES_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get discounts.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getDiscounts (queryparams) {
  return axios
    .get(`${api.DISCOUNTS_URL}`, {params: queryparams, withCredentials: false})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get taxes.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getTaxes (queryparams) {
  return axios
    .get(`${api.TAXES_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get Gratuities.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getGratuities (queryparams) {
  return axios
    .get(`${api.GRATUITY_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get Collected By data (staff).
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getStaffs (queryparams) {
  return axios
    .get(`${api.COLLECTEDBY_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

/**
 * Get servers.
 * @param {date} startDate, endDate
 * @returns {Promise.<T>|*|Promise<R>} JSON object from server, or Error object if fails.
 */
export function getServers (queryparams) {
  return axios
    .get(`${api.SERVEDBY_URL}`, {params: queryparams, withCredentials: true})
    .then(response => {
      return Promise.resolve(response)
    }).catch(error => {
      return Promise.reject(new Error(error.message))
    })
}

export function exportTransaction (query) {
  return axios.get(`${api.EXPORT_TRANSACTION}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportSummary (query) {
  return axios.get(`${api.EXPORT_SUMMARY}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportGrossProfit (query) {
  return axios.get(`${api.EXPORT_GROSS_PROFIT}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportPaymentMethod (query) {
  return axios.get(`${api.EXPORT_PAYMENT_METHOD}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportItemSales (query) {
  return axios.get(`${api.EXPORT_ITEM_SALES}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportCategorySales (query) {
  return axios.get(`${api.EXPORT_CATEGORY_SALES}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportModifierSales (query) {
  return axios.get(`${api.EXPORT_MODIFIER_SALES}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportDiscounts (query) {
  return axios.get(`${api.EXPORT_DISCOUNT}`, {params: query, withCredentials: false})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportTaxes (query) {
  return axios.get(`${api.EXPORT_TAXES}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportGratuity (query) {
  return axios.get(`${api.EXPORT_GRATUITY}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportColectedBy (query) {
  return axios.get(`${api.EXPORT_COLLECTEDBY}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}

export function exportServedBy (query) {
  return axios.get(`${api.EXPORT_SERVEDBY}`, {params: query, withCredentials: true})
    .then((response) => {
      return Promise.resolve(response)
    }).catch((error) => {
      if (error.response) {
        let eobj = new Error(error.response.errors)
        return Promise.reject(eobj)
      }
      return Promise.reject(error)
    })
}



// WEBPACK FOOTER //
// ./app/api/sales.js